import { useEffect, useState } from 'react';
import { useWeb3 } from '../context/Web3Context';
import { useContracts } from './useContract';
import { isSameAddress } from '../utils/format';
import { areContractsConfigured } from '../config/contracts';

// Determines if current connected wallet is owner or admin of Storage.
export const useAdminCheck = () => {
  const { account, rightNetwork } = useWeb3();
  const { storageR } = useContracts();

  const [checking, setChecking] = useState(false);
  const [isOwner, setIsOwner]   = useState(false);
  const [isAdmin, setIsAdmin]   = useState(false);
  const [ownerAddr, setOwnerAddr] = useState(null);
  const [adminAddr, setAdminAddr] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!account || !rightNetwork || !storageR || !areContractsConfigured()) {
        setIsOwner(false);
        setIsAdmin(false);
        setOwnerAddr(null);
        setAdminAddr(null);
        return;
      }
      setChecking(true);
      setError(null);
      try {
        const [o, a] = await Promise.all([
          storageR.owner(),
          storageR.admin()
        ]);
        if (cancelled) return;
        setOwnerAddr(o);
        setAdminAddr(a);
        setIsOwner(isSameAddress(o, account));
        setIsAdmin(isSameAddress(a, account));
      } catch (e) {
        if (cancelled) return;
        setError('Failed to read contract owner/admin');
      } finally {
        if (!cancelled) setChecking(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [account, rightNetwork, storageR]);

  return {
    checking,
    isOwner,
    isAdmin,
    isPrivileged: isOwner || isAdmin,
    ownerAddr,
    adminAddr,
    error
  };
};
